export class Validation {
  isInValid: boolean;
  errorMessage: string;
  errorCss: string;
  index: number;
}
